import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import '../../styles/signUpDialog.css'
import InputStyle from '../../assets/InputStyle';
import ResetPasswordModal from './ResetPasswordModal';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { verifyEmailOTPForForgotPassword, verifyPhoneOTPToForgotPassword } from '../../actions/userAuth';
import { isValidPhoneNumber, isValidateEmail } from '../../utils/common';
import { enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';


export default function ForgetPasswordOtpModal({ forgetPasswordOtpAction, setForgetPasswordOtpAction, emailOrPhone, otpToken }) {
  const [resetPasswordAction, setResetPasswordAction] = useState(false);
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    setForgetPasswordOtpAction(false);
  }

  const handleOtpSubmit = () => {
    setLoading(true);
    if (otp != "" && isValidateEmail(emailOrPhone)) {
      dispatch(verifyEmailOTPForForgotPassword({ emailOtp: otp, email: emailOrPhone }, (data) => {
        setToken(data.data.activation_token);
        enqueueSnackbar("Otp verified successfully", { variant: 'success' });
        setLoading(false);
        setForgetPasswordOtpAction(false);
        setResetPasswordAction(true);
      }, (err) => {
        enqueueSnackbar("Error occured! please try again", { variant: 'error' });
        setLoading(false);
      }, otpToken))
    } else if (otp != "" && isValidPhoneNumber(emailOrPhone)) {
      dispatch(verifyPhoneOTPToForgotPassword({ phoneOtp: otp, phone: emailOrPhone.includes('+') ? emailOrPhone : `+91${emailOrPhone}` }, (data) => {
        setToken(data.data.activation_token);
        enqueueSnackbar("Otp verified successfully", { variant: 'success' });
        setLoading(false);
        setForgetPasswordOtpAction(false);
        setResetPasswordAction(true);
      }, (err) => {
        enqueueSnackbar("Error occured! please try again", { variant: 'error' });
        setLoading(false);
      }, otpToken))
    } else {
      enqueueSnackbar("Please enter valid Otp", { variant: 'error' });
      setLoading(false);
    }
  }

  return (
    <>
      <Dialog
        open={forgetPasswordOtpAction}
        onClose={closeHandler}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <CloseIcon sx={{float:'right', cursor:'pointer'}} onClick={closeHandler}/>
        </DialogTitle>
        <DialogContent >
          <Box px={6} py={3}>
            <Typography

              sx={{ fontWeight: 700, mb: 4, textAlign: 'center', color: '#2544EE', fontSize: 22, fontFamily: 'Inter', }}
              component={'h3'}
            >
              Forget Password
            </Typography>

            <Stack spacing={3}>

              <InputStyle name="OTP" topSpace={true}>
                <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
              </InputStyle>
              <Button disabled={loading} onClick={handleOtpSubmit} variant="contained" fullWidth sx={{ bgcolor: '#2544EE', width: '92%' }}>
                {loading
                  ?
                  <CircularProgress size={24}/>
                  :
                  "Submit"}
              </Button>

            </Stack>

          </Box>
        </DialogContent>
      </Dialog>
      <ResetPasswordModal
      activationToken={token}
        resetPasswordAction={resetPasswordAction}
        setResetPasswordAction={setResetPasswordAction}
      />
    </>
  );
}
